import {Action} from '@ngrx/store';
import {User} from '../user.model';

export const GET_ACTUAL_USER = 'GET_ACTUAL_USER';
export const GET_ACTUAL_USER_BY_UID = 'GET_ACTUAL_USER_BY_UID';
export const SET_USER = 'SET_USER';
export const CHANGE_USER = 'CHANGE_USER';
export const CHANGE_PASSWORD_USER = 'CHANGE_PASSWORD_USER';
export const REGISTER_TRIAL_USER = 'REGISTER_TRIAL_USER';

export class GetActualUser implements Action {
  readonly type = GET_ACTUAL_USER;
}

export class GetActualUserByUid implements Action {
  readonly type = GET_ACTUAL_USER_BY_UID;
}

export class SetUser implements Action {
  readonly type = SET_USER;

  constructor(
    public payload: User
  ) {}
}

export class ChangeUser implements Action {
  readonly type = CHANGE_USER;

  constructor(public payload: {id: number, params: any, config: any}) {
  }
}

export class ChangeUserPassword implements Action {
  readonly type = CHANGE_PASSWORD_USER;

  constructor(public payload: {id: number, password: string, retypedPassword: string}) {
  }
}

export class RegisterTrialUser implements Action {
  readonly type = REGISTER_TRIAL_USER;

  constructor(public payload: {id: number, email: string, password: string, retypedPassword: string, params: any}) {
  }
}

export type UserActions = GetActualUser | GetActualUserByUid | SetUser | ChangeUser | ChangeUserPassword
  | RegisterTrialUser
  ;

